import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "login form" }, [
      _createElementVNode("h2", null, "Welkom bij Simplex Flow"),
      _createElementVNode("p", null, [
        _createTextVNode("Log in via de "),
        _createElementVNode("a", { href: "https://app.simplexconnect.nl" }, "Simplex AppStore"),
        _createTextVNode("!")
      ])
    ], -1)
  ]))]))
}